<template>
  <div class="cost_main">
    <h3
      class="y_title"
      v-text="title"
    />
    <ul class="cost_list">
      <template v-for="item in list">
        <cost-item
          :id="item.period"
          :key="item.period"
          :title="title"
          :name="item.name"
          :status="item.status === 1"
        />
      </template>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
import costItem from './CostItem'
export default {
  components: {
    costItem
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => ({})
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
.cost_main {
  margin-bottom: 8px;
  .y_title {
    font-weight: 500;
    color: #333;
    text-shadow: 1px #979797;
    margin: 8px 0 12px 12px;
  }
  .cost_list {
    background: #fff;
    border-top: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
  }
}
</style>
